<template>
  <v-select
    label="Select"
    v-model="selected_potentiality"
    :items="potentiality"
    :class="['contact-v-select', potentialityClass]"
    :disabled="!hasWritePermission"
    @update:modelValue="updatePotentiality()"
    variant=""
    no-details
  >
    <template v-slot:item="{ item, props }">
      <v-list-item
        v-bind="props"
        :title="item.raw"
        :style="{
          color:
            item.raw === 'VIP'
              ? '#1c6572'
              : item.raw === 'A'
              ? '#0464bc'
              : item.raw === 'B'
              ? '#c14a05'
              : item.raw === 'C'
              ? '#d91313'
              : '',
          background:
            item.raw === 'VIP'
              ? '#e9f8fc'
              : item.raw === 'A'
              ? '#f5fafe'
              : item.raw === 'B'
              ? '#fefbf1'
              : item.raw === 'C'
              ? '#fef3f2'
              : '',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }"
      >
      </v-list-item>
    </template>
  </v-select>
</template>
<script>
import apiClient from "@/core/buildRequest";
import { useContactsStore } from "@/store/crm/useContactsStore";
import { loginForm } from "@/store/logIn";


export default {
  name: "PotentialityCol",
  props: ["item", "id"],
  data() {
    return {
      selected_potentiality: "",
      potentiality: ["VIP", "A", "B", "C"],
      loginStore: loginForm(),
    };
  },
  mounted() {
    this.selected_potentiality = this.item.potentiality;
  },
  computed: {
    potentialityClass() {
      switch (this.selected_potentiality) {
        case "VIP":
          return "contact-v-select-prime";
        case "A":
          return "contact-v-select-blue";
        case "B":
          return "contact-v-select-orange";
        case "C":
          return "contact-v-select-red";
        default:
          return ""; // Return empty if no class is applicable
      }
    },
    hasWritePermission() {
      return this.loginStore?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
  },
  watch: {
    "item.potentiality"(newVal) {
      this.selected_potentiality = newVal;
    },
  },

  methods: {
    async updatePotentiality() {
      await apiClient
        .post(`/leads-managment/contacts/potentiality/${this.id}`, {
          potentiality: this.selected_potentiality,
        })
        .then((res) => {
          const contact_store = useContactsStore();
          contact_store?.updatePotentiality(
            this.id,
            this.selected_potentiality
          );
        });
    },
    handleClickPermission() {
      if (!this.hasWritePermission) return;
      
    },
    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
  },
};
</script>
